module.exports = __webpack_public_path__ + "img/voltaje_a_gray.2583337f.svg";